/**
 * StickerMessageMC - Componente para mostrar un mensaje de sticker en el Inbox.
 */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import MessageStatusMC from './MessageStatusMC';
import ImageMC from '../../../components/ImageMC';

const StickerMessageMC = memo(({
  message,
  conversation,
  onClick
}) => {
  const { t } = useTranslation('InboxMC');

  return (
    <div className="tw-relative !tw-h-[300px] tw-border-[5px] tw-rounded-[14px] !tw-bg-white">
      <ImageMC
        platform={conversation.platform}
        data={message}
        onClick={onClick}
        alt={t('image.alt')}
        className="tw-block tw-cursor-pointer tw-object-cover tw-w-full tw-h-full tw-rounded-[9px]"
      />
      <MessageStatusMC isMedia message={message} platform={conversation.platform} containerClassName="!tw-text-white" />
    </div>
  );
});

StickerMessageMC.displayName = 'StickerMessageMC';

export default StickerMessageMC;
